export default [
  {
    path: "/",
    text: "about",
  },
  {
    path: "/",
    text: "packages",
  },
  {
    path: "/",
    text: "contact",
  },
]
